module.exports = __webpack_public_path__ + "static/10-16d2b839750e2245d111cc48afb5bd12.jpg";